import { RecordingIndicator } from "./recording-indicator";
import { ControlButton } from "./control-button";
import { CheckIcon, DiscardIcon } from "../icons";
import { formatTime } from "../utils";

interface RecordingControlsProps {
  disabled?: boolean;
  isRecording: boolean;
  recordingTime: number;
  onAccept: () => void;
  onDiscard: () => void;
}

export function RecordingControls({
  disabled,
  isRecording,
  recordingTime,
  onAccept,
  onDiscard,
}: RecordingControlsProps) {
  return (
    <div className="recording-controls" aria-hidden={!isRecording}>
      <div className="time">{formatTime(recordingTime)}</div>
      <RecordingIndicator />
      <ControlButton
        disabled={disabled}
        onClick={onAccept}
        ariaLabel="Accept recording"
        icon={<CheckIcon />}
      />
      <ControlButton
        disabled={disabled}
        onClick={onDiscard}
        ariaLabel="Discard recording"
        icon={<DiscardIcon />}
      />
    </div>
  );
}
